import { tryFetchRelatedContentInsights } from '../actions/publicActions';
import { isInsightsEnabledForEvent } from 'owa-meeting-insights-types-and-flights';
import { lazyFetchMeetingInsights } from 'owa-meeting-insights';
import { orchestrator } from 'satcheljs';

export default orchestrator(tryFetchRelatedContentInsights, actionMessage => {
    const { eventId, dataFetchSource } = actionMessage;

    if (isInsightsEnabledForEvent(eventId)) {
        // We only fetch the related contents for meeting events
        lazyFetchMeetingInsights.importAndExecute(eventId, dataFetchSource).catch(() => {
            /* The catch is to swallow the thrown error from fetchMeetingInsights. No need to handle the error as it is already logged inside fetchMeetingInsights.
             * fetchMeetingInsights has to return a rejected promise to tell if the task is completed or not, for the TaskQueue to schedule the next fetch task.
             */
        });
    }
});
